import { accountKeys } from '@/hooks/api/useAccounts'
import { collectorKeys } from '@/hooks/api/useCollectors'
import { paymentKeys } from '@/hooks/api/usePayments'
import { subscriptionKeys } from '@/hooks/api/useSubscriptions'
import { QueryClient } from '@tanstack/react-query'

export const invalidateAgreementCache = (
  queryClient: QueryClient,
  agreementId: string,
) => {
  queryClient.invalidateQueries({ queryKey: subscriptionKeys.subscriptions(agreementId) })
  queryClient.invalidateQueries({ queryKey: subscriptionKeys.installments(agreementId) })
  queryClient.invalidateQueries({ queryKey: paymentKeys.agreementPayments(agreementId) })
  queryClient.invalidateQueries({ queryKey: accountKeys.lists() })
}

export const invalidateAgreementCacheWithLists = (
  queryClient: QueryClient,
  agreementId: string,
) => {
  invalidateAgreementCache(queryClient, agreementId)
  queryClient.invalidateQueries({ queryKey: subscriptionKeys.lists() })
}

export const invalidateCollectorAndAgreementCache = (
  queryClient: QueryClient,
  agreementId: string,
) => {
  queryClient.invalidateQueries({ queryKey: collectorKeys.all })
  invalidateAgreementCache(queryClient, agreementId)
}
